import { ViewClinician } from "@/features/patient/appointments/components/view/view-clinician";

function PatientViewClinicians() {
    return (
        <div className="flex flex-1 flex-col">
            <ViewClinician />
        </div>
    );
}

export default PatientViewClinicians;
